/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ComplexDependencies } from './dependenciesComplexClass.generated.js';
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated.js';
import { ceilDependencies } from './dependenciesCeil.generated.js';
import { equalScalarDependencies } from './dependenciesEqualScalar.generated.js';
import { floorDependencies } from './dependenciesFloor.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { zerosDependencies } from './dependenciesZeros.generated.js';
import { createFix } from '../../factoriesAny.js';
export var fixDependencies = {
  ComplexDependencies,
  DenseMatrixDependencies,
  ceilDependencies,
  equalScalarDependencies,
  floorDependencies,
  matrixDependencies,
  typedDependencies,
  zerosDependencies,
  createFix
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesFix.generated.js
// module id = 540
// module chunks = 2